module.exports = __webpack_public_path__ + "static/media/CodeC.d374171f.png";